const timeout = 500;

export function longify(value) {
  setTimeout(value, timeout);
}
